import React from 'react';
import Alert from './Alert';
import Confirm from './Confirm';
import Modal from './Modal';

const OverlayContainer = () => (
    <>
        <Alert />
        <Confirm />
        <Modal />
    </>
);

export default OverlayContainer;
